import { BrowserRouter, HashRouter, Route, Routes, useParams } from 'react-router-dom';
import './App.css';
import OTPLogin from './components/OTPLogin';
import './assets/lineawesome/css/line-awesome.min.css'
import { useAuth } from './context/AuthContext';
import Dashboard from './pages/Dashboard';
import { ToastContainer } from 'react-toastify';
import Departments from './pages/Departments';
import Appointments from './pages/Appointments';
import SlotBooking from './pages/SlotBooking';
import OtherPatient from './pages/OtherPatient';
import Holidays from './pages/Holidays';
import usePreventInspect from './security/UsePreventConsole';
import LabResults from './pages/LabResults';
import './styles/colors.css';
import TermsAndConditionsPage from './pages/TermsAndConditionsPage';
import Policies from './pages/Policies';
import About from './components/About';

function App() {
  const Auth = useAuth();
  const noAuth = window.location.href.includes('/user-access');
  //usePreventInspect();
  return (
    <div className="App life">
       {
       Auth.userIsFullAuthenticated() ?
        <HashRouter>
          <Routes>
            <Route exact path="/" element={<Dashboard/>} />
            <Route exact path="/departments" element={<Departments />} />
            <Route exact path="/appointment" element={<Appointments />} />
            <Route path="/slotbooking" element={<SlotBooking />} />
            <Route path="/otherpatient" element={<OtherPatient />} />
              <Route path="/holidays" element={<Holidays />} />
              <Route path="/about" element={<About/>} />
            <Route path="/labresults/*" element={<LabResults/>} />
              <Route path="/terms" element={<TermsAndConditionsPage />} />
              <Route path="/policies" element={<Policies/>} />
          </Routes>
        </HashRouter>
        :
        <>{!Auth.userIsFullAuthenticated() && !noAuth ? 
          <OTPLogin/> : 
          <HashRouter>
            <Routes>
              <Route path="/labresults/*" element={<LabResults/>} />
            </Routes>
          </HashRouter>
        }</>
      }
      <ToastContainer theme="colored" draggable pauseOnHover autoClose={5000}/>
    </div>
  );
}

export default App;
